/**
 * Ad related constants
 */

/**
 * All ticker time events that should render an ad
 */
const AdTickerEvent = {
    PERIOD_END: 'PERIOD_END',
    OVERTIME_END: 'OVERTIME_END',
    SHOOT_OUT_END: 'SHOOT_OUT_END',
    HALFTIME_END: 'HALFTIME_END',
    GAME_END: 'GAME_END'
};

export {AdTickerEvent};
